import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HELPERS from "utils/helper";
import { selectTasks, selectUpcomingMeetings } from "../../slices/dashboardSlice";
import "./calendar.css";
import "./style.css";
import { Link } from "react-router-dom";
import useCustomizeDash from "hooks/useCustomizeDash";
import DASHBOARD_API from "api/dashboard";
import { message } from "antd";

const Calendar = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
  const currentDate = moment();
  const tasks = useSelector(selectTasks);
  // const upcomingMeetings = useSelector(selectUpcomingMeetings);
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  const [dateObject, setDateObject] = useState(moment());
  const [selectedDay, setSelectedDay] = useState(null);
  const weekdayshort = moment.weekdaysShort();
  const { isDropdownOpen } = useCustomizeDash();
  const userId = HELPERS.getUserId();

  const getDaysInMonth = () => {
    return dateObject.daysInMonth();
  };

  const getCurrentDay = () => {
    return parseInt(currentDate.format("D"));
  };
  useEffect(() => {
    DASHBOARD_API.geAlltUpcomingMeetings(userId, true).then((resp) => {
      console.log(resp, "checking res upcoming")
      // dispatch(updateUpcomingMettingsFilters({}))
      if (resp && resp.data.upcoming_meetings) {
        // dispatch(updateUpcomingMettings(resp.data.upcoming_meetings))
        setUpcomingMeetings(resp.data.upcoming_meetings)
      }
    });
  }, [])

  const getCurrentMonth = () => {
    return currentDate.format("MMMM");
  };

  const firstDayOfMonth = () => {
    return moment(dateObject).startOf("month").format("d"); // Day of week 0...1..5...6;
  };

  const month = () => {
    return dateObject.format("MMMM");
  };

  const onPrev = () => {
    setDateObject(dateObject.clone().subtract(1, "month"));
  };

  const onNext = () => {
    setDateObject(dateObject.clone().add(1, "month"));
  };

  const coachEvents = tasks.map((task) => {
    const dueDate = moment(task.due_date);
    if (
      (task.weekly_reflection > 0 || task.step_reflection > 0) &&
      dueDate.month() === dateObject.month()
    ) {
      // HELPERS.log(
      //   `Coach Task ${task.title} is due by ${dueDate} and currentDate is ${dateObject}`
      // );
      return dueDate.date();
    }

    return 0;
  });

  const personalEvents = tasks.map((task) => {
    const dueDate = moment(task.due_date);
    if (
      !task.weekly_reflection &&
      !task.step_reflection &&
      dueDate.month() === dateObject.month()
    ) {
      // HELPERS.log(
      //   `Personal Task ${task.title} is due by ${dueDate} and currentDate is ${dateObject}`
      // );
      return dueDate.date();
    }

    return 0;
  });

  console.log(`sss upcoming_meeting ${dateObject}`, upcomingMeetings, tasks, personalEvents);
  const upcomingMeetingEvents = upcomingMeetings.map((meeting) => {
    const dueDate = moment(`${meeting.date} ${meeting.time}`, "YYYY-MM-DD hh:mm:ss A");

    // HELPERS.log(`sss upcoming_meeting ${meeting.title} is due by ${dueDate} is due by ${dueDate}`);
    // return 0
    if (
      dueDate.month() === dateObject.month()
    ) {
      HELPERS.log(`sss upcoming_meeting if ${meeting.title} is due by ${dueDate} and currentDate is ${dateObject}`);
      return dueDate.date();
    }

    return 0;
  })

  const onDayClick = (e, d) => {
    setSelectedDay(parseInt(d));
  };

  let weekdayshortname = weekdayshort.map((day, i) => {
    return <th key={`calendar-week-${i}`}>{day}</th>;
  });

  let blanks = [];
  for (let i = 0; i < firstDayOfMonth(); i++) {
    blanks.push(
      <td key={`calendar-day-empty-${i}`} className="calendar-day empty">
        {""}
      </td>
    );
  }

  HELPERS.log("Current day", getCurrentDay());

  let daysInMonth = [];
  for (let d = 1; d <= getDaysInMonth(); d++) {
    let currentDay =
      d === getCurrentDay() && month() === getCurrentMonth() ? "today" : "";
    let selectedDayClass = d === selectedDay ? " selected-day " : "";
    let personalEvent = personalEvents.indexOf(d) !== -1;
    let coachEvent = coachEvents.indexOf(d) !== -1;
    let upcomingMeetingEvent = upcomingMeetingEvents.indexOf(d) !== -1;
    // console.log(`sss upcoming_meeting`, personalEvent, coachEvent, upcomingMeetingEvent, d)
    let events = null;
    if (personalEvent || coachEvent || upcomingMeetingEvent) {
      events = [];

      if (personalEvent && coachEvent && upcomingMeetingEvent) {
        events.push(
          <span key={`coach-event-${d}-1`} className="personal event-dot" />
        );
        events.push(
          <span key={`coach-event-${d}-2`} className="coach event-dot" />
        );
        events.push(
          <span key={`coach-event-${d}-3`} className="upcoming_meeting event-dot" />
        );
      }
      if (personalEvent) {
        events.push(
          <span key={`coach-event-${d}-1`} className="personal event-dot" />
        );
        if (personalEvents.filter((e) => e === d).length > 1) {
          events.push(
            <span key={`coach-event-${d}-2`} className="personal event-dot" />
          );
        }
      }
      if (coachEvent) {
        events.push(
          <span key={`coach-event-${d}-1`} className="coach event-dot" />
        );
        if (coachEvents.filter((e) => e === d).length > 1) {
          events.push(
            <span key={`coach-event-${d}-2`} className="coach event-dot" />
          );
        }
      }
      if (upcomingMeetingEvent) {
        events.push(
          <span key={`coach-event-${d}-1`} className="upcoming_meeting event-dot" />
        );
        if (upcomingMeetingEvents.filter((e) => e === d).length > 1) {
          events.push(
            <span key={`coach-event-${d}-2`} className="upcoming_meeting event-dot" />
          );
        }
      }
      
      events = (
        <span key={`coach-events-${d}`} className="events">
          {events}
        </span>
      );
    }
    // console.log(`sss upcoming_meeting events`, events)

    daysInMonth.push(
      <td
        key={d}
        className={`calendar-day ${currentDay} ${selectedDayClass}`}
        onClick={(e) => {
          onDayClick(e, d);
        }}
      >
        <span>{d}</span>
        {events}
      </td>
    );
  }

  
  let totalSlots = [...blanks, ...daysInMonth];
  let rows = [];
  let cells = [];
  
  totalSlots.forEach((row, i) => {
    if (i % 7 !== 0) {
      cells.push(row);
    } else {
      rows.push(cells);
      cells = [];
      cells.push(row);
    }
    if (i === totalSlots.length - 1) {
      // let insertRow = cells.slice();
      rows.push(cells);
    }
  });
  
  daysInMonth = rows.map((d, i) => {
    return <tr key={`calendar-day-${i}`}>{d}</tr>;
  });
  // console.log(`sss upcoming_meeting daysInMonth`, daysInMonth, totalSlots)
  
  HELPERS.log(`Rendering calendar with events`, personalEvents);

  const handleDelete = () => {
    // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
    try {
      const payload = { "step_id": compID, "user_id": userId }
      console.log("sss delete", payload);
      DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
        message.success("Your work has been saved")
        setTmpState(!tmpState)
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  return (
    <>
      <div
        className="tail-datetime-calendar-wrapper"
        style={{ display: "grid" }}
      >
        <div className="tail-datetime-calendar">
          <div className="calendar-navi">
            <span onClick={onPrev} className="calendar-button button-prev" />
            <span className="calendar-label">{month()}</span>
            <span onClick={onNext} className="calendar-button button-next" />
          </div>
          <div className="calendar-date">
            <table className="calendar-day">
              <thead>
                <tr>{weekdayshortname}</tr>
              </thead>
              <tbody>
                {daysInMonth}</tbody>
            </table>
          </div>
        </div>
        <Link
          to="/calendar"
          style={{ textAlign: "left", paddingBottom: "10px" }}
        >
          See full calendar
        </Link>
      </div>
      { isDropdownOpen ? (
        <img
          src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
          alt="delete icon"
          className="delete-icon"
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "30px",
          }}
          onClick={handleDelete}
        />
      ) : null 
      }
    </>
  );
};

export default Calendar;
